module.exports = __webpack_public_path__ + "static/media/radiationAlt.a2709410.svg";